import React, { useEffect, useState } from "react";
import { PiEngineFill } from "react-icons/pi";
import { GrConnect } from "react-icons/gr";
import { GiSpring } from "react-icons/gi";
import { FaDrumSteelpan } from "react-icons/fa6";
import { GiTyre } from "react-icons/gi";
import { FaTachometerAlt } from "react-icons/fa";
import { FaCar } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { GoChecklist } from "react-icons/go";
import { MdOutlineCarCrash } from "react-icons/md";
import { GiCarKey } from "react-icons/gi";
import { BsBank } from "react-icons/bs";
import { FaBook } from "react-icons/fa";
import { FaCheck } from "react-icons/fa6";
import ProgressBar from "react-bootstrap";
import { BsFillLightningFill } from "react-icons/bs";
import { RxCross2 } from "react-icons/rx";
import { IoSettingsOutline } from "react-icons/io5";
import { IoMdPerson } from "react-icons/io";
import { LiaImageSolid } from "react-icons/lia";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { Baseurl } from "../../config/BaseUrl";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom/dist";
import { moment } from "moment";
import { useSelector } from "react-redux";
import "react-circular-progressbar/dist/styles.css";
import {
  CircularProgressbar,
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import RadialSeparators from "./RadialSeparators";
import { PiEngine } from "react-icons/pi";
import { GiGearStick } from "react-icons/gi";


const ConstructionReport = () => {
  const params = useParams();
  const navigate = useNavigate()
  const { organisationLogo } = useSelector((store) => store.orgLogo);
  const { brandLogo } = useSelector((store) => store.brandLogo);
  const [caseinfo, setcaseinfo] = useState("");
  const [casePerfomanceinfo, setcasePerfomanceinfo] = useState({});
  const [caseEngine, setCaseEngine] = useState({});
  const [caseTransmission, setCaseTransmission] = useState({});
  const [caseSuspension, setCaseSuspension] = useState({});
  const [caseBrakes, setCaseBrakes] = useState({});
  const [caseTyre, setCaseTyre] = useState({});
  const [caseInterior, setCaseInterior] = useState({});
  const [caseExterior, setCaseExterior] = useState({});
  const [caseRating, setCaseRating] = useState({});
  const [temploading, setTempLoading] = useState(false);
  const [percentage, setPercentage] = useState(66);

  //   console.log(casePerfomanceinfo,"1");
  // console.log(casePerfomanceinfo.findBrakesCon,"findBrakesCon");

  const roundImageArray = [
    {
      label: "Poor",
      percentage: 2,
      roundImage: "/assets/Adsum Advisory Services Pvt. Ltd._files/leg02.png",
    },
    {
      label: "Average",
      percentage: 4,
      roundImage: "/assets/Adsum Advisory Services Pvt. Ltd._files/leg04.png",
    },
    {
      label: "Satisfactory",
      percentage: 5,
      roundImage: "/assets/Adsum Advisory Services Pvt. Ltd._files/leg06.png",
    },
    {
      label: "Good",
      percentage: 7,
      roundImage: "/assets/Adsum Advisory Services Pvt. Ltd._files/ovleg07.png",
    },
    {
      label: "Excellent",
      percentage: 9,
      roundImage: "/assets/Adsum Advisory Services Pvt. Ltd._files/leg09.png",
    },
  ];
  const selectImageArray = [
    {
      label: "Poor",
      lineImage: "/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png",
    },
    {
      label: "Average",
      lineImage: "/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png",
    },
    {
      label: "Satisfactory",
      lineImage: "/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png",
    },
    {
      label: "Good",
      lineImage: "/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png",
    },
    {
      label: "Excellent",
      lineImage: "/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png",
    },
  ];

  useEffect(() => {
    const caseId = params.caseId;
    const fetchData = async () => {
      try {
        const url = `${Baseurl}/api/v1/cases/individualcase/${caseId}`;
        const caseFetch = await axios.get(url);

        try {
          if (caseFetch.data.success) {
            const casedetails = caseFetch.data.case;

            setcaseinfo(casedetails);
            const vehicleType = casedetails.assetType;
            const carCasDetails = casedetails.construction;

            let findEngineCon = "";
            let findTransmissionCon = "";
            let findSuspensionCon = "";
            let findBrakesCon = "";
            let findTyreCon = "";
            let findInteriorCon = "";
            let findExteriorCon = "";
            let finalBreakCondition = "";
            let finalTyreCondition = "";

            let transmission = carCasDetails.transmission.transmissionCondition;
            if (vehicleType === "Construction Equipment") {
              findEngineCon = roundImageArray.find(
                (data) =>
                  data.label === casedetails.otherDetails.engineCondition
              );

              findTransmissionCon = roundImageArray.find(
                (data) => data.label === carCasDetails.transmission.transmissionCondition
              );

              findSuspensionCon = roundImageArray.find(
                (data) =>
                  data.label === carCasDetails.suspension.suspensionCondition
              );

              findInteriorCon = roundImageArray.find(
                (data) =>
                  data.label === casedetails.otherDetails.interiorCondition
              );

              findExteriorCon = roundImageArray.find(
                (data) =>
                  data.label === casedetails.otherDetails.exteriorCondition
              );

              const findRareBrakesCon = roundImageArray.find(
                (data) =>
                  data.label === casedetails.otherDetails.frontBrakeCondition
              );

              const findFrontBrakesCon = roundImageArray.find(
                (data) =>
                  data.label === casedetails.otherDetails.rearBrakeCondition
              );


              const TotalTyreCon =
                Number(carCasDetails.TyresNConditions.lhRear) +
                Number(carCasDetails.TyresNConditions.lhFront) +
                Number(carCasDetails.TyresNConditions.rhRear) +
                Number(carCasDetails.TyresNConditions.rhFront)

              console.log(TotalTyreCon, "TotalTyreCon");

              findTyreCon = Number(TotalTyreCon) / 40;
              findTyreCon = Math.round(findTyreCon);

              console.log(findTyreCon, "findTyreCon");

              if (findTyreCon === 1 || findTyreCon === 2) {
                finalTyreCondition = 2;
              } else if (findTyreCon === 3 || findTyreCon === 4) {
                finalTyreCondition = 4;
              } else if (findTyreCon === 5 || findTyreCon === 6) {
                finalTyreCondition = 5;
              } else if (findTyreCon === 7 || findTyreCon === 8) {
                finalTyreCondition = 7;
              } else if (findTyreCon === 9 || findTyreCon === 10) {
                finalTyreCondition = 9;
              }

              console.log(finalTyreCondition, "finalTyreCondition");

              console.log(findFrontBrakesCon, "finalTyreCondition");
              console.log(findRareBrakesCon, "finalTyreCondition");

              const totalBrackcon =
                Number(findFrontBrakesCon.percentage) +
                Number(findRareBrakesCon.percentage);
              findBrakesCon = Number(totalBrackcon) / 2;
              findBrakesCon = Math.round(findBrakesCon);

              if (findBrakesCon === 1 || findBrakesCon === 2) {
                finalBreakCondition = 2;
              } else if (findBrakesCon === 3 || findBrakesCon === 4) {
                finalBreakCondition = 4;
              } else if (findBrakesCon === 5 || findBrakesCon === 6) {
                finalBreakCondition = 5;
              } else if (findBrakesCon === 7 || findBrakesCon === 8) {
                finalBreakCondition = 7;
              } else if (findBrakesCon === 9 || findBrakesCon === 10) {
                finalBreakCondition = 9;
              }

              const findBreakCondition = roundImageArray.find(
                (data) => data.percentage === finalBreakCondition
              );
              const findTyreCondition = roundImageArray.find(
                (data) => data.percentage === finalTyreCondition
              );
              console.log(finalBreakCondition, "finalBreakCondition");
              console.log(findTyreCondition, "finalTyreCondition111");

              const overalRating =
                Number(findEngineCon.percentage) +
                Number(findTransmissionCon.percentage) +
                Number(findSuspensionCon.percentage) +
                Number(findInteriorCon.percentage) +
                Number(findExteriorCon.percentage) +
                Number(finalBreakCondition) +
                Number(finalTyreCondition);

              const overalavg = Number(overalRating) / 7;

              setCaseEngine(findEngineCon)
              setCaseTransmission(findTransmissionCon)
              setCaseSuspension(findSuspensionCon)
              setCaseBrakes(findBreakCondition)
              setCaseTyre(findTyreCondition)
              setCaseInterior(findInteriorCon)
              setCaseExterior(findExteriorCon)
              setCaseRating(overalavg.toFixed(2))

            } else {
            }
          }
        } catch (error) { }
      } catch (error) { }
    };
    fetchData();
  }, [params.caseId]);

  console.log(caseinfo, "caseinfo");



  return (
    <>
      {caseinfo ? (
        <>
          <div>
            <div
              className="content"
              style={{
                border: "1px solid #686868",
                padding: "0 10px",
                width: "100%",
                position: "relative",
              }}
            >
              {/* A4 size */}
              <div className="row noprint p-3">
                <div className="col-sm-6">
                  <a
                    href=""
                    className="btn btn-success"
                    onclick="window.print();"
                  >
                    Print
                  </a>
                </div>
                <div className="col-sm-6 text-right">
                  <a href="" className="btn btn-success">
                    Cancel
                  </a>
                </div>
              </div>
              <div
                className="row"
                style={{
                  padding: "0 15px",
                  fontSize: "12pt",
                  fontWeight: "bold",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div className="col-sm-6">
                  Ref. No / Loan No&nbsp;:&nbsp;{caseinfo.loanAgreementNo}
                </div>
                {caseinfo.caseId > 0 && caseinfo.caseId < 10 ? (
                  <>
                    {" "}
                    <div className="col-sm-6 text-right">
                      Case ID&nbsp;:&nbsp;0{caseinfo.caseId}
                    </div>
                  </>
                ) : (
                  <>
                    {" "}
                    <div className="col-sm-6 text-right">
                      Case ID&nbsp;:&nbsp;{caseinfo.caseId}
                    </div>
                  </>
                )}
              </div>
              <div
                style={{
                  padding: "2px 25px",
                  border: "1px solid #000",
                  width: "100%",
                }}
              >
                <div className="row">
                  <div className="col-sm-3 p-2">
                    <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/toplogo.png" />
                  </div>
                  <div className="col-sm-6 text-center">
                    {/* <br /> */}
                    <h4>
                      <strong>
                        Valuation Report
                        <br />
                        {caseinfo.assetType}
                        <br />
                        <strong>{`${caseinfo.brand} ${caseinfo.model} ${caseinfo.variant}`}</strong>
                      </strong>
                    </h4>
                    {/* <br /> */}
                    &nbsp;&nbsp;
                  </div>
                  <div className="col-sm-3 text-right">
                    <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png" />
                  </div>
                </div>
              </div>
              <div style={{ padding: "5px 15px" }}>
                <div className="row">
                  <div className="col-sm-7">
                    {/* ==== main col 7*/}
                    <div className="row" style={{ paddingRight: 15 }}>
                      <div
                        className="col-sm-12 newReport"
                        style={{
                          marginTop: 2,
                          border: "1px solid #000",
                          padding: "3px 5px",
                        }}
                      >
                        <strong>{`${caseinfo.brand} ${caseinfo.model} ${caseinfo.variant}`}</strong>
                      </div>
                    </div>
                    <div className="row" style={{ paddingRight: 15 }}>
                      <div
                        className="col-sm-12 newReport"
                        style={{
                          marginTop: 2,
                          border: "1px solid #000",
                          padding: "3px 5px",
                        }}
                      >
                        City : {caseinfo.city}
                      </div>
                    </div>
                    <div className="row" style={{ paddingRight: 15 }}>
                      <div
                        className="col-sm-12 newReport"
                        style={{
                          marginTop: 2,
                          border: "1px solid #000",
                          padding: "3px 5px",
                        }}
                      >
                        Color : {caseinfo.vehicleColor}
                      </div>
                    </div>
                    <div className="row" style={{ paddingRight: 15 }}>
                      <div
                        className="col-sm-12 newReport"
                        style={{
                          marginTop: 2,
                          border: "1px solid #000",
                          padding: "3px 5px",
                        }}
                      >
                        Odometer in Kms : {caseinfo.meterReading}
                      </div>
                    </div>
                    <div className="row" style={{ paddingRight: 15 }}>
                      <div
                        className="col-sm-12 newReport"
                        style={{
                          marginTop: 2,
                          border: "1px solid #000",
                          padding: "3px 5px",
                        }}
                      >
                        Fuel Type : {caseinfo.fueltype}
                      </div>
                    </div>
                    <div className="row" style={{ paddingRight: 15 }}>
                      <div
                        className="col-sm-12 newReport"
                        style={{
                          marginTop: 2,
                          border: "1px solid #000",
                          padding: "3px 5px",
                        }}
                      >
                        Transmission :{" "}
                        {caseinfo.additionalFeatures.transmission}
                      </div>
                    </div>
                    <div className="row" style={{ paddingRight: 15 }}>
                      <div
                        className="col-sm-12 newReport"
                        style={{
                          marginTop: 2,
                          border: "1px solid #000",
                          padding: "3px 5px",
                        }}
                      >
                        Accedental status : {caseinfo.otherDetails.accidental}
                      </div>
                    </div>
                    <div className="row" style={{ paddingRight: 15 }}>
                      <div
                        className="col-sm-12 newReport"
                        style={{
                          marginTop: 1,
                          padding: "3px 5px",
                          backgroundColor: "#d6d6d6",
                        }}
                      >
                        <span style={{ color: "#000", fontWeight: "bold" }}>
                          Ex. Showroom Price&nbsp;:{caseinfo.marketPrice}
                        </span>
                      </div>
                    </div>
                    <div className="row" style={{ paddingRight: 15 }}>
                      <div
                        className="col-sm-12 newReport"
                        style={{
                          marginTop: 1,
                          padding: "3px 5px",
                          backgroundColor: "#d6d6d6",
                        }}
                      >
                        <span style={{ color: "#000", fontWeight: "bold" }}>
                          Estimated Market Value :{caseinfo.valuation}
                        </span>
                      </div>
                    </div>
                  </div>
                  {/* ==== main col 7 end */}
                  <div className="col-sm-5 text-center imfix">
                    <img
                      src={caseinfo.images.frontImage}
                      className="fixed-img"
                    />
                    <br />
                  </div>
                </div>
              </div>
              {/* ====================================================================== */}
              <div className="row" style={{ padding: "1px 1px" }}>
                <div
                  className="col-sm-12 newReport"
                  style={{ border: "1px solid #000", borderRadius: 2 }}
                >
                  <table width="100%" style={{ padding: "5px 5px" }}>
                    <tbody>
                      <tr>
                        <td width="12">
                          <div className="center-round">
                            <div className="legcontainer">
                              <img
                                src={caseEngine.roundImage}
                                alt="Small Image"
                                className="small-image"
                              />
                              <img
                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/engine.png"
                                className="image1"
                                alt="Image 1"
                              />
                            </div>
                          </div>
                        </td>
                        <td width="12.5%">
                          <div className="center-round">
                            <div className="legcontainer">
                              <img
                                src={caseTransmission.roundImage}
                                alt="Small Image"
                                className="small-image"
                              />
                              <img
                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/transm.png"
                                className="image1"
                                alt="Image 1"
                              />
                            </div>
                          </div>
                        </td>
                        <td width="12.5%">
                          <div className="center-round">
                            <div className="legcontainer">
                              <img
                                src={caseSuspension.roundImage}
                                alt="Small Image"
                                className="small-image"
                              />
                              <img
                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/Suspension.png"
                                className="image1"
                                alt="Image 1"
                              />
                            </div>
                          </div>
                        </td>
                        <td width="12.5%">
                          <div className="center-round">
                            <div className="legcontainer">
                              <img
                                src={caseBrakes.roundImage}
                                alt="Small Image"
                                className="small-image"
                              />
                              <img
                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/Brakes.png"
                                className="image1"
                                alt="Image 1"
                                style={{height:'28px',width:'30px'}}
                              />
                            </div>
                          </div>
                        </td>
                        <td width="12.5%">
                          <div className="center-round">
                            <div className="legcontainer">
                              <img
                                src={caseTyre.roundImage}
                                alt="Small Image"
                                className="small-image"
                              />
                              <img
                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/tyres.png"
                                className="image1"
                                alt="Image 1"
                              />
                            </div>
                          </div>
                        </td>
                        <td width="12.5%">
                          <div className="center-round">
                            <div className="legcontainer">
                              <img
                                // src="/assets/Adsum Advisory Services Pvt. Ltd._files/leg06.png"
                                src={caseInterior.roundImage}
                                alt="Small Image"
                                className="small-image"
                              />
                              <img
                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/interior.png"
                                className="image1"
                                alt="Image 1"
                                style={{height:'28px',width:'30px'}}
                              />
                            </div>
                          </div>
                        </td>
                        <td width="12.5%">
                          <div className="center-round">
                            <div className="legcontainer">
                              <img
                                // src="/assets/Adsum Advisory Services Pvt. Ltd._files/leg06.png"
                                src={caseExterior.roundImage}
                                alt="Small Image"
                                className="small-image"
                              />
                              <img
                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/Exterior.png"
                                className="image1"
                                alt="Image 1"
                                style={{height:'28px',width:'30px'}}
                              />
                            </div>
                          </div>
                        </td>
                        <td width="12.5%">
                          {caseRating > 0.01 && caseRating < 2 ? (
                            <>
                              <div className="center-round">
                                <div className="legcontainer">
                                  <img
                                    //   src="/assets/Adsum Advisory Services Pvt. Ltd._files/ovleg07.png "
                                    src="/assets/Adsum Advisory Services Pvt. Ltd._files/leg02.png"
                                    alt="Small Image"
                                    className="small-image"
                                  />
                                  <h1
                                    className="image1"
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    {caseRating}
                                  </h1>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              {caseRating > 2.01 && caseRating < 4 ? (
                                <>
                                  <div className="center-round">
                                    <div className="legcontainer">
                                      <img
                                        //   src="/assets/Adsum Advisory Services Pvt. Ltd._files/ovleg07.png "
                                        src="/assets/Adsum Advisory Services Pvt. Ltd._files/leg04.png"
                                        alt="Small Image"
                                        className="small-image"
                                      />
                                      <h1
                                        className="image1"
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        {caseRating}
                                      </h1>
                                    </div>
                                  </div>
                                </>
                              ) : (
                                <>
                                  {caseRating > 4.01 && caseRating < 6 ? (
                                    <>
                                      <div className="center-round">
                                        <div className="legcontainer">
                                          <img
                                            //   src="/assets/Adsum Advisory Services Pvt. Ltd._files/ovleg07.png "
                                            src="/assets/Adsum Advisory Services Pvt. Ltd._files/leg06.png"
                                            alt="Small Image"
                                            className="small-image"
                                          />
                                          <div>
                                            <h1
                                              className="image1"
                                              style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                              }}
                                            >
                                              {caseRating}
                                            </h1>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      {caseRating > 6.01 && caseRating < 8 ? (
                                        <>
                                          <div className="center-round">
                                            <div className="legcontainer">
                                              <img
                                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/ovleg07.png "
                                                // src="/assets/Adsum Advisory Services Pvt. Ltd._files/leg07.png"
                                                alt="Small Image"
                                                className="small-image"
                                              />
                                              <h1
                                                className="image1"
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                }}
                                              >
                                                {caseRating}
                                              </h1>
                                            </div>
                                          </div>
                                        </>
                                      ) : (
                                        <>
                                          <div className="center-round">
                                            <div className="legcontainer">
                                              <img
                                                //   src="/assets/Adsum Advisory Services Pvt. Ltd._files/ovleg07.png "
                                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/leg09.png"
                                                alt="Small Image"
                                                className="small-image"
                                              />
                                              <h1
                                                className="image1"
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                }}
                                              >
                                                {caseRating}
                                              </h1>
                                            </div>
                                          </div>
                                        </>
                                      )}
                                    </>
                                  )}
                                </>
                              )}
                            </>
                          )}
                        </td>
                      </tr>
                      <tr className="legtext">
                        <td>
                          Engine
                          {/* <br /> */}
                          <p> {caseEngine.percentage}/10</p>
                        </td>
                        <td>
                          Transmission
                          {/* <br /> */}
                          <p>{caseTransmission.percentage}/10</p>
                        </td>
                        <td>
                          Suspension
                          {/* <br /> */}
                          <p> {caseSuspension.percentage}/10</p>
                        </td>
                        <td>
                          Brakes
                          {/* <br /> */}
                          <p>{caseBrakes.percentage}/10</p>
                        </td>
                        <td>
                          Tyres
                          {/* <br /> */}
                          <p>{caseTyre.percentage}/10</p>
                        </td>
                        <td>
                          Interior
                          {/* <br /> */}
                          <p>{caseInterior.percentage}/10</p>
                        </td>
                        <td>
                          Exterior
                          {/* <br /> */}
                          <p> {caseExterior.percentage}/10</p>
                        </td>
                        <td>
                          <strong>
                            OVERALL
                            {/* <br /> */}
                            <p> {caseRating} of 10</p>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              {/* ====================================================================== */}
              <div className="row">
                <div className="col-sm-12 newReport">
                  <table
                    width="100%"
                    border={1}
                    style={{ fontSize: "10pt", border: "1px solid #688" }}
                  >
                    <tbody>
                      <tr className="p-3">
                        <td width="75%" rowSpan={2}>
                          &nbsp;&nbsp;&nbsp;&nbsp;Inspection Address
                          {/* <br /> */}
                          &nbsp;&nbsp;&nbsp;&nbsp;{caseinfo.vehicleLocation}
                        </td>
                        <td className="text-center">
                          Created Date
                          {/* <br /> */}
                          {caseinfo.createdAt.slice(0, 10)}
                        </td>
                      </tr>
                      <tr>
                        <td className="text-center">
                          Service Date
                          {/* <br /> */}
                          {caseinfo.submittedAt.slice(0, 10)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              {/* <div style={{ padding: 8 }} /> */}
              <table>
                <tbody>
                  <tr>
                    <td>
                      <div className="imgcontainer">
                        <img
                          src="/assets/Adsum Advisory Services Pvt. Ltd._files/car01.jpg"
                          className="image3"
                        />
                      </div>
                    </td>
                    <td>
                      <strong>&nbsp;&nbsp;VEHICLE DETAILS</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="row">
                <div className="col-sm-12 newReport">
                  {/* *=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*= */}
                  <table width="100%">
                    <tbody>
                      <tr style={{ height: "30px" }}>
                        <td width="24%">
                          <div className="col-sm-12 newReport column-ht">
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/car08.jpg"
                              width="auto"
                              height="10%"
                            />
                            <p style={{ fontSize: '12px' }}>
                              Registration
                            </p>
                            {/* <br /> */}
                            <p style={{ fontSize: '13px' }}> <strong>{caseinfo.regdNo}</strong></p>
                            <hr />
                            <p style={{ fontSize: '12px' }}>
                              Chasis Number
                            </p>
                            {/* <br /> */}
                            <p style={{ fontSize: '13px' }}> <strong>
                              {caseinfo.chasisNo}

                            </strong></p>
                            <hr />
                            <p style={{ fontSize: '12px' }}>
                              Engine Number
                            </p>
                            {/* <br /> */}
                            <p style={{ fontSize: '13px' }}> <strong>
                              {caseinfo.engNo}

                            </strong></p>
                            <hr />
                          </div>
                        </td>
                        <td width="24%">
                          <div className="col-sm-12 newReport column-ht">
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/car02.jpg"
                              width="auto"
                              height="10%"
                            />
                            <p style={{ fontSize: '12px' }}>
                              Body Type
                            </p>
                            {/* <br /> */}
                            <p style={{ fontSize: '13px' }}><strong>{caseinfo.bodyType}</strong></p>
                            <hr />
                            <p style={{ fontSize: '12px' }}>
                              Manufacture Year
                            </p>
                            {/* <br /> */}
                            <p style={{ fontSize: '13px' }}> <strong>{caseinfo.manufacturingDate}</strong></p>
                            {/* <br /> */}
                            <p style={{ fontSize: '12px' }}>
                              Date of Regd.
                            </p>
                            {/* <br /> */}
                            <p style={{ fontSize: '13px' }}><strong>{caseinfo.regdDate}</strong></p>
                            <hr />
                            <p style={{ fontSize: '12px' }}>
                              Vehicle Type
                            </p>
                            {/* <br /> */}
                            <p style={{ fontSize: '13px' }}><strong>{caseinfo.assetType}</strong></p>
                          </div>
                        </td>
                        <td width="25%">
                          <div className="col-sm-12 newReport column-ht">
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/car03.jpg"
                              width="auto"
                              height="10%"
                            />
                            <p style={{ fontSize: '12px' }}>

                              Owner Name
                            </p>
                            {/* <br /> */}
                            <p style={{ fontSize: '13px' }}> <strong>{caseinfo.regdOwner.length > 15 ? caseinfo.regdOwner.slice(0, 14) : caseinfo.regdOwner}...</strong></p>
                            <hr />
                            <p style={{ fontSize: '12px' }}>
                              Owner Serial No
                            </p>
                            {/* <br /> */}
                            <p style={{ fontSize: '13px' }}> <strong> {caseinfo.ownerSerialNo}</strong></p>

                            <hr />
                            <p style={{ fontSize: '12px' }}>
                              Proposed Owner Name
                            </p>
                            {/* <br /> */}
                            <p style={{ fontSize: '13px' }}> <strong>{caseinfo.name}</strong></p>
                            <hr />
                            {/* <br /> */}
                          </div>
                        </td>
                        <td width="25%">
                          <div className="col-sm-12 newReport column-ht">
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/car04.jpg"
                              width="auto"
                              height="10%"
                            />
                            {/* <br /> */}
                            <p style={{ fontSize: '12px' }}>
                              Report Requested by
                            </p>
                            {/* <br /> */}
                            <p style={{ fontSize: '13px' }}> {caseinfo.requesterName}</p>
                            <hr />
                            <p style={{ fontSize: '12px' }}>
                              Case Type
                            </p>
                            {/* <br /> */}
                            <p style={{ fontSize: '13px' }}> <strong>{caseinfo.caseType}</strong></p>
                            <hr />
                            <p style={{ fontSize: '12px' }}>
                              Purpose Of Valuation
                            </p>
                            {/* <br /> */}
                            <p style={{ fontSize: '13px' }}><strong>{caseinfo.valuationPurpose}</strong></p>
                            <hr />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  {/* *=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*= */}
                  <div style={{ padding: 2 }} />
                  <table border={1} width="100%">
                    <tbody>
                      <tr
                        className="text-center"
                        style={{ border: "1px solid black", height: "30px" }}
                      >
                        <td
                          width="50%"
                          style={{ borderRight: "1px solid #686868" }}
                        >
                          Insurance Company
                          {/* <br /> */}
                          <p><strong>{caseinfo.insuranceCompany}</strong></p>
                        </td>
                        <td width="25%">
                          Insurance Status
                          {/* <br /> */}
                          <div>
                            {caseinfo.insuranceStatus === "Yes" ? (
                              <strong>Expired</strong>
                            ) : (
                              <strong>Running</strong>
                            )}
                          </div>
                        </td>
                        <td style={{ borderLeft: "1px solid #686868" }}>
                          Insurance Valid Till
                          {/* <br /> */}
                          <strong>
                            {caseinfo.otherDetails.insuranceExpiry}
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  {/* <div style={{ padding: 5 }} /> */}
                  <table width="100%">
                    <tbody>
                      <tr style={{ height: "30px" }}>
                        <td width="65%" style={{ border: "1px solid #686868" }}>
                          &nbsp;&nbsp;Remarks&nbsp;:&nbsp;{caseinfo.yourRemark}
                          <br />
                          &nbsp;&nbsp;
                          <a className="ps-2" target="_blank" href={caseinfo.videos} style={{ color: 'blue', textDecoration: 'underline' }}>
                            Preview Video Clip
                          </a>
                          &nbsp;
                          <a style={{ color: 'blue', textDecoration: 'underline' }} target="_blank"
                            href={caseinfo.imageUrl}
                          >
                            Preview Images
                          </a>
                        </td>
                        <td
                          width="35%"
                          rowSpan={2}
                          style={{ border: "1px solid black" }}
                        >
                          <div className="text-center">
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <img
                                src="/assets/stamp.jpeg"
                                width="40px"
                                height="40px"
                              />
                            </div>
                            <div>Authorized Signatory</div>
                            <br />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td width="65%" style={{ border: "1px solid #686868" }}>
                          &nbsp;&nbsp;Field Service By:&nbsp;
                          {caseinfo.fieldServiceBy}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12 newReport">
                  <div
                    style={{
                      padding: 2,
                      border: "1px solid #000",
                      width: "100%",
                    }}
                  >
                    {/* page footer */}
                    <div className="col-sm-12 newReport text-center">
                      <strong>Head Office:</strong>
                      {/* <br /> */}
                      <p>
                        {" "}
                        Door No. 411,4th Floor, Eden Amsri Square,beside Apollo
                        Hospital, Sangeet Circle,
                      </p>
                      {/* <br /> */}
                      <p> Secunderabad 500003, Telengana</p>
                    </div>
                  </div>
                </div>
              </div>
              {/* page footer ends */}
              {/* <div style={{ padding: 5 }} /> */}
            </div>

            <div className="page-break" />
            <div
              className="content"
              style={{
                margin: "20px 0 0 0",
                padding: "0 10px",
                width: "100%",
                border: "1px solid #000",
              }}
            >
              <div style={{ marginTop: 5 }}></div>
              <div
                style={{
                  padding: "2px 15px",
                  border: "1px solid #000",
                  width: "100%",
                }}
              >
                <div className="row">
                  <div className="col-sm-3 p-2">
                    <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/toplogo.png" />
                  </div>
                  <div className="col-sm-6 text-center">
                    <h4>
                      <strong>
                        Valuation Report
                        {/* <br /> */}
                        <p> {caseinfo.assetType}</p>
                        {/* <br /> */}
                        <p>
                          {" "}
                          <strong>{`${caseinfo.brand} ${caseinfo.model} ${caseinfo.variant}`}</strong>
                        </p>
                      </strong>
                    </h4>
                  </div>
                  <div className="col-sm-3 text-right">
                    <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png" />
                  </div>
                </div>
              </div>

              {/*-  header */}
              <div className="row">
                <div className="col-sm-12 newReport">
                  <table
                    className="rcrowheight rtborder"
                    style={{ borderCollapse: "collapse" }}
                    width="100%"
                  >
                    <tbody>
                      <tr style={{ height: "10px" }}>
                        <td>
                          <strong>REGISTRATION DETAILS</strong>
                        </td>
                        <td>
                          <strong>AS PER VAHAN</strong>
                        </td>
                        <td>
                          <strong>AS PER RC</strong>
                        </td>
                        <td>
                          <strong>AS PER ACTUAL</strong>
                        </td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Vehicle Registration No</td>
                        <td>{caseinfo.vehicleEdetails.regNo}</td>
                        <td>{caseinfo.vehicleEdetails.regNo}</td>
                        <td>{caseinfo.regdNo}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Chasis No&nbsp;:&nbsp;</td>
                        <td>{caseinfo.vehicleEdetails.chassis}</td>
                        <td>{caseinfo.vehicleEdetails.chassis}</td>
                        <td>{caseinfo.chasisNo}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Engine No&nbsp;:&nbsp;</td>
                        <td> {caseinfo.vehicleEdetails.engine}</td>
                        <td>{caseinfo.vehicleEdetails.engine}</td>
                        <td>{caseinfo.engNo}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Vehicle Color</td>
                        <td>{caseinfo.vehicleEdetails.vehicleColour}</td>
                        <td>{caseinfo.vehicleEdetails.vehicleColour}</td>
                        <td>{caseinfo.vehicleColor}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Fuel Type&nbsp;:&nbsp;</td>
                        <td>{caseinfo.vehicleEdetails.type}</td>
                        <td>{caseinfo.vehicleEdetails.type}</td>
                        <td>{caseinfo.fueltype}</td>
                      </tr>

                      <tr style={{ height: "10px" }}>
                        <td width="35%">Owner Serial No</td>
                        <td>{caseinfo.vehicleEdetails.ownerCount}</td>
                        <td>{caseinfo.vehicleEdetails.ownerCount}</td>
                        <td>{caseinfo.ownerSerialNo}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Reg Owner Name</td>
                        <td>{caseinfo.vehicleEdetails.owner}</td>
                        <td>{caseinfo.vehicleEdetails.owner}</td>
                        <td>{caseinfo.regdOwner}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Date Of Registration</td>
                        <td> {caseinfo.vehicleEdetails.regDate}</td>
                        <td> {caseinfo.vehicleEdetails.regDate}</td>
                        <td>{caseinfo.regdDate}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">RTA Name</td>
                        <td> {caseinfo.vehicleEdetails.regAuthority}</td>
                        <td> {caseinfo.vehicleEdetails.regAuthority}</td>
                        <td>-</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Year Of Manufacture</td>
                        <td>{caseinfo.vehicleEdetails.vehicleManufacturingMonthYear}</td>
                        <td>{caseinfo.vehicleEdetails.vehicleManufacturingMonthYear}</td>
                        <td>{caseinfo.regdDate}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Fitness Expiry Date</td>
                        <td>{caseinfo.vehicleEdetails.rcExpiryDate}</td>
                        <td>{caseinfo.vehicleEdetails.rcExpiryDate}</td>
                        <td>{caseinfo.otherDetails.roadTaxValidity}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Insurance Exp Date</td>
                        <td>{caseinfo.vehicleEdetails.vehicleInsuranceUpto}</td>
                        <td>{caseinfo.vehicleEdetails.vehicleInsuranceUpto}</td>
                        <td>{caseinfo.otherDetails.insuranceExpiry}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Tax Valid Up To</td>
                        <td>{caseinfo.vehicleEdetails.vehicleTaxUpto}</td>
                        <td>{caseinfo.vehicleEdetails.vehicleTaxUpto}</td>
                        <td>-</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Permit Up To</td>
                        <td>{caseinfo.vehicleEdetails.permitValidUpto}</td>
                        <td>{caseinfo.vehicleEdetails.permitValidUpto}</td>
                        <td>-</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Permit Type</td>
                        <td>{caseinfo.vehicleEdetails.permitType}</td>
                        <td>{caseinfo.vehicleEdetails.permitType}</td>
                        <td>-</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Hypothecation</td>
                        <td>{caseinfo.vehicleEdetails.rcFinancer}</td>
                        <td>{caseinfo.vehicleEdetails.rcFinancer}</td>
                        <td> {caseinfo.hypothecationBank}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Cubic Capacity</td>
                        <td>{caseinfo.vehicleEdetails.vehicleCubicCapacity}</td>
                        <td>{caseinfo.vehicleEdetails.vehicleCubicCapacity}</td>
                        <td>{caseinfo.cubicCapacity}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Gross Vehicle Weight</td>
                        <td>{caseinfo.vehicleEdetails.grossVehicleWeight}</td>
                        <td>{caseinfo.vehicleEdetails.grossVehicleWeight}</td>
                        <td>{caseinfo.vehicleWeight}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Seating Capacity</td>
                        <td> {caseinfo.vehicleEdetails.vehicleSeatCapacity}</td>
                        <td> {caseinfo.vehicleEdetails.vehicleSeatCapacity}</td>
                        <td>{caseinfo.seatingCapacity}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Number Plate</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>{caseinfo.numberPlate}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Status</td>
                        <td>{caseinfo.vehicleEdetails.status}</td>
                        <td>{caseinfo.vehicleEdetails.status}</td>
                        <td>&nbsp;</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Blacklist Status</td>
                        <td>{caseinfo.vehicleEdetails.blacklistStatus}</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Is Commercial</td>
                        {caseinfo.assetType === "Commercial" ? (
                          <td>Yes</td>
                        ) : (
                          <td>no</td>
                        )}
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Challan Details</td>
                        <td>NA</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                      </tr>
                    </tbody>
                  </table>
                  <h4 style={{ marginTop: "5px" }}>
                    <strong>OTHERS:</strong>
                  </h4>
                  <table className="rowheight" width="100%">
                    <tbody>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Document</td>
                        <td colSpan={2}> {caseinfo.documentVerification}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Asset Type</td>
                        <td colSpan={2}>{caseinfo.assetType}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Manufacturing Year</td>
                        <td colSpan={2}> {caseinfo.manufacturingDate}</td>
                      </tr>
                    </tbody>
                  </table>
                  <h4 style={{ marginTop: "5px" }}>
                    <strong>DOCUMENT DETAILS:</strong>
                  </h4>
                  <table className="rowheight" width="100%">
                    <tbody>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Fitness Expiry Date</td>
                        <td colSpan={2}>
                          {" "}
                          {caseinfo.otherDetails.fitnessExpiry}
                        </td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Insurance</td>
                        <td colSpan={2}>{caseinfo.insuranceCompany}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Road Tax Validity Upto</td>
                        <td colSpan={2}>
                          {" "}
                          {caseinfo.otherDetails.roadTaxValidity}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div style={{ marginTop: 10 }}>&nbsp;</div>
            </div>
            {/* <!-- page 2 ends --> */}

            <div className="page-break" />
            <div
              className="content"
              style={{
                margin: "20px 0 0 0",
                padding: "0 10px",
                width: "100%",
                border: "1px solid #000",
              }}
            >
              <div
                style={{
                  padding: "2px 15px",
                  border: "1px solid #000",
                  width: "100%",
                }}
              >
                <div className="row">
                  <div className="col-sm-3 p-1">
                    <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/toplogo.png" />
                  </div>
                  <div className="col-sm-6 text-center">
                    <h4>
                      <strong>
                        Valuation Report
                        {/* <br /> */}
                        <p>{caseinfo.assetType}</p>
                        {/* <br /> */}
                        <p> {`${caseinfo.brand} ${caseinfo.model} ${caseinfo.variant}`}</p>
                      </strong>
                    </h4>
                    &nbsp;
                  </div>
                  <div className="col-sm-3 text-right">
                    <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png" />
                  </div>
                </div>
              </div>
              {/*-  header */}
              <h4 style={{ marginTop: "5px" }}>
                <strong>OTHER DETAILS:</strong>
              </h4>
              <table className="rowheight" width="100%">
                <tbody>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Fuel Type</td>
                    <td colSpan={2}>{caseinfo.fueltype}</td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Gross Vehicle Weight</td>
                    <td colSpan={2}>{caseinfo.vehicleWeight}</td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Odormeter Type</td>
                    <td colSpan={2}>
                      {" "}
                      {caseinfo.additionalFeatures.odometer}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Cubic Capacity</td>
                    <td colSpan={2}>{caseinfo.cubicCapacity}</td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Vehicle Color</td>
                    <td colSpan={2}>{caseinfo.vehicleColor}</td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Meter Reading In Km</td>
                    <td colSpan={2}>{caseinfo.meterReading}</td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Number Plate</td>
                    <td width="30%">{caseinfo.numberPlate}</td>
                    <td width="30%"></td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Seating Capacity</td>
                    <td colSpan={2}>{caseinfo.seatingCapacity}</td>
                  </tr>
                </tbody>
              </table>
              <h4 style={{ marginTop: "5px" }}>
                <strong>ENGINE:</strong>
              </h4>
              <table className="rowheight" width="100%">
                <tbody>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Engine</td>
                    <td width="30%"> {caseinfo.construction.engine.engine}</td>
                    <td width="30%">
                      {caseinfo.construction.engine.engine === "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Engine Condition</td>
                    <td width="30%">{caseinfo.otherDetails.engineCondition}</td>
                    <td width="30%">
                      {caseinfo.otherDetails.engineCondition === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.engineCondition === "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.engineCondition ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.engineCondition === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.engineCondition === "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Fluid Leaks</td>
                    <td width="30%">
                      {" "}
                      {caseinfo.construction.engine.fluidLeak}
                    </td>
                    <td width="30%">
                      {caseinfo.construction.engine.fluidLeak === "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Engine Shield</td>
                    <td width="30%">
                      {caseinfo.construction.engine.engineShield}
                    </td>
                    <td width="30%">
                      {caseinfo.construction.engine.engineShield === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.engine.engineShield ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.engine.engineShield ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.engine.engineShield === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.engine.engineShield ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
              <h4 style={{ marginTop: "5px" }}>
                <strong>TRANSMISSION:</strong>
              </h4>
              <table className="rowheight" width="100%">
                <tbody>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Transmission Type</td>
                    <td width="30%">
                      {caseinfo.additionalFeatures.transmission}
                    </td>
                    <td width="30%">
                      <span>&nbsp;</span>
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%"> Transmission Condition</td>
                    <td width="30%">
                      {caseinfo.construction.transmission.transmissionCondition}
                    </td>
                    <td width="30%">
                      {caseinfo.construction.transmission
                        .transmissionCondition === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.transmission
                        .transmissionCondition === "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.transmission
                        .transmissionCondition === "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.transmission
                        .transmissionCondition === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.transmission
                        .transmissionCondition === "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
              <h4 style={{ marginTop: "5px" }}>
                <strong>SUSPENSION</strong>
              </h4>
              <table className="rowheight" width="100%">
                <tbody>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Suspension Condition</td>
                    <td width="30%">
                      {caseinfo.construction.suspension.suspensionCondition}
                    </td>
                    <td width="30%">
                      {caseinfo.construction.suspension.suspensionCondition ===
                        "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.suspension.suspensionCondition ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.suspension.suspensionCondition ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.suspension.suspensionCondition ===
                        "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.suspension.suspensionCondition ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
              <h4 style={{ marginTop: "5px" }}>
                <strong>BRAKES</strong>
              </h4>
              <table className="rowheight" width="100%">
                <tbody>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Front Brake Condition</td>
                    <td width="30%">
                      {caseinfo.otherDetails.frontBrakeCondition}
                    </td>
                    <td width="30%">
                      {caseinfo.otherDetails.frontBrakeCondition === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.frontBrakeCondition ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.frontBrakeCondition ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.frontBrakeCondition === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.frontBrakeCondition ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Rear Brake Condition</td>
                    <td width="30%">
                      {caseinfo.otherDetails.rearBrakeCondition}
                    </td>
                    <td width="30%">
                      {caseinfo.otherDetails.rearBrakeCondition === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.rearBrakeCondition ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.rearBrakeCondition ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.rearBrakeCondition === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.rearBrakeCondition ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Hand Brake</td>
                    <td width="30%">
                      {caseinfo.construction.brakes.handBrake}
                    </td>
                    <td width="30%">
                      {caseinfo.construction.brakes.handBrake === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.brakes.handBrake === "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.brakes.handBrake ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.brakes.handBrake === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.brakes.handBrake ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
              <h4 style={{ marginTop: "5px" }}>
                <strong>TYRES CONDITION</strong>
              </h4>
              <table className="rowheight" width="100%">
                <tbody>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Type</td>
                    <td width="30%">
                      {caseinfo.construction.TyresNConditions.type}
                    </td>
                    <td width="30%"></td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Lh Front</td>
                    <td width="30%">
                      {caseinfo.construction.TyresNConditions.lhFront}
                    </td>
                    <td width="30%">
                      {caseinfo.construction.TyresNConditions.lhFront >= "0" &&
                        caseinfo.construction.TyresNConditions.lhFront <= 20 ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.TyresNConditions.lhFront >=
                        "20.01" &&
                        caseinfo.construction.TyresNConditions.lhFront <= "40" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.TyresNConditions.lhFront >=
                        "40.01" &&
                        caseinfo.construction.TyresNConditions.lhFront <= "60" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.TyresNConditions.lhFront >=
                        "60.01" &&
                        caseinfo.construction.TyresNConditions.lhFront <= "80" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.TyresNConditions.lhFront >=
                        "80.01" &&
                        caseinfo.construction.TyresNConditions.lhFront <=
                        "100" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Rh Front</td>
                    <td width="30%">
                      {caseinfo.construction.TyresNConditions.rhFront}
                    </td>
                    <td width="30%">
                      {caseinfo.construction.TyresNConditions.rhFront >= "0" &&
                        caseinfo.construction.TyresNConditions.rhFront <= 20 ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.TyresNConditions.rhFront >=
                        "20.01" &&
                        caseinfo.construction.TyresNConditions.rhFront <= "40" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.TyresNConditions.rhFront >=
                        "40.01" &&
                        caseinfo.construction.TyresNConditions.rhFront <= "60" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.TyresNConditions.rhFront >=
                        "60.01" &&
                        caseinfo.construction.TyresNConditions.rhFront <= "80" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.TyresNConditions.rhFront >=
                        "80.01" &&
                        caseinfo.construction.TyresNConditions.rhFront <=
                        "100" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Lh Rear</td>
                    <td width="30%">
                      {caseinfo.construction.TyresNConditions.lhRear}
                    </td>
                    <td width="30%">
                      {caseinfo.construction.TyresNConditions.lhRear >= "0" &&
                        caseinfo.construction.TyresNConditions.lhRear <= 20 ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.TyresNConditions.lhRear >=
                        "20.01" &&
                        caseinfo.construction.TyresNConditions.lhRear <= "40" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.TyresNConditions.lhRear >=
                        "40.01" &&
                        caseinfo.construction.TyresNConditions.lhRear <= "60" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.TyresNConditions.lhRear >=
                        "60.01" &&
                        caseinfo.construction.TyresNConditions.lhRear <= "80" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.TyresNConditions.lhRear >=
                        "80.01" &&
                        caseinfo.construction.TyresNConditions.lhRear <= "100" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Rh Rear</td>
                    <td width="30%">
                      {caseinfo.construction.TyresNConditions.rhRear}
                    </td>
                    <td width="30%">
                      {caseinfo.construction.TyresNConditions.rhRear >= "0" &&
                        caseinfo.construction.TyresNConditions.rhRear <= 20 ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.TyresNConditions.rhRear >=
                        "20.01" &&
                        caseinfo.construction.TyresNConditions.rhRear <= "40" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.TyresNConditions.rhRear >=
                        "40.01" &&
                        caseinfo.construction.TyresNConditions.rhRear <= "60" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.TyresNConditions.rhRear >=
                        "60.01" &&
                        caseinfo.construction.TyresNConditions.rhRear <= "80" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.TyresNConditions.rhRear >=
                        "80.01" &&
                        caseinfo.construction.TyresNConditions.rhRear <= "100" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  {caseinfo.otherDetails.spareTyre > "0" ? (
                    <tr style={{ height: "10px" }}>
                      <td width="35%">Spare</td>
                      <td width="30%">
                        {caseinfo.construction.TyresNConditions.spareTyre}
                      </td>
                      <td width="30%">
                        {caseinfo.construction.TyresNConditions.spareTyre >=
                          "0" &&
                          caseinfo.construction.TyresNConditions.rhRear <= 20 ? (
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                        ) : (
                          <></>
                        )}
                        {caseinfo.construction.TyresNConditions.spareTyre >=
                          "20.01" &&
                          caseinfo.construction.TyresNConditions.rhRear <=
                          "40" ? (
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                        ) : (
                          <></>
                        )}
                        {caseinfo.construction.TyresNConditions.spareTyre >=
                          "40.01" &&
                          caseinfo.construction.TyresNConditions.rhRear <=
                          "60" ? (
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                        ) : (
                          <></>
                        )}
                        {caseinfo.construction.TyresNConditions.spareTyre >=
                          "60.01" &&
                          caseinfo.construction.TyresNConditions.rhRear <=
                          "80" ? (
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                        ) : (
                          <></>
                        )}
                        {caseinfo.construction.TyresNConditions.spareTyre >=
                          "80.01" &&
                          caseinfo.construction.TyresNConditions.rhRear <=
                          "100" ? (
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                        ) : (
                          <></>
                        )}
                      </td>
                    </tr>
                  ) : (
                    <></>
                  )}
                </tbody>
              </table>
              <table className="rowheight" width="100%">
                <tbody>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Total Tyres Ex Spare</td>
                    <td width="30%">{caseinfo.otherDetails.totalTyre}</td>
                    <td width="30%">-</td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Available Tyres</td>
                    <td width="30%">{caseinfo.otherDetails.availableTyre}</td>
                    <td width="30%">-</td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Missing Tyres</td>
                    <td width="30%">{caseinfo.otherDetails.missingTyre}</td>
                    <td width="30%">-</td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Spare Tyre</td>
                    <td width="30%">{caseinfo.otherDetails.spareTyre}</td>
                    <td width="30%">-</td>
                  </tr>
                </tbody>
              </table>



              {/* <div className="row">
                <div className="col-sm-12 newReport">
                  <div
                    style={{
                      padding: 2,
                      border: "1px solid #000",
                      width: "100%",
                    }}
                  >
                 
                    <div className="col-sm-12 newReport text-center">
                      <strong>Head Office:</strong>
                      <br />
                      J15-A, LANE NO-40, RAJAPURI,J15-UTTAM NAGAR,DELHI, 110059
                      <br />
                      Phone: 9866773092 | Email: pankaj623@gmail.com | Website:
                      https://www.adsum.co.in
                    </div>
                  </div>
                </div>
              
              </div>
              <div style={{ marginTop: 10 }}>&nbsp;</div> */}
            </div>
            {/* <!-- page 3 ends --> */}

            <div className="page-break" />
            <div
              className="content"
              style={{
                margin: "30px 0 0 0",
                padding: "0 10px",
                width: "100%",
                border: "2px solid #000",
              }}
            >
              <div
                style={{
                  padding: "2px 25px",
                  border: "1px solid #000",
                  width: "100%",
                }}
              >
                <div className="row">
                  <div className="col-sm-3 p-2">
                    <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/toplogo.png" />
                  </div>
                  <div className="col-sm-6 text-center">
                    <h4>
                      <strong>
                        Valuation Report
                        {/* <br /> */}
                        <p> {caseinfo.assetType}</p>
                        {/* <br /> */}
                        <p> {`${caseinfo.brand} ${caseinfo.model} ${caseinfo.variant}`}</p>
                      </strong>
                    </h4>
                    &nbsp;
                  </div>
                  <div className="col-sm-3 text-right">
                    <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png" />
                  </div>
                </div>
              </div>
              {/*-  header */}
              <h4 style={{ marginTop: "5px" }}>
                <strong>VEHICLE INTERIOR:</strong>
              </h4>
              <table className="rowheight" width="100%">
                <tbody>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Steering</td>
                    <td width="30%">
                      {caseinfo.construction.vehicleInterior.steering}
                    </td>
                    <td width="30%">
                      {caseinfo.construction.vehicleInterior.steering ===
                        "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleInterior.steering ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleInterior.steering ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleInterior.steering ===
                        "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleInterior.steering ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Steering Condition</td>
                    <td width="30%">
                      {caseinfo.construction.vehicleInterior.steeringCondition}
                    </td>
                    <td width="30%">
                      {caseinfo.construction.vehicleInterior
                        .steeringCondition === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleInterior
                        .steeringCondition === "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleInterior
                        .steeringCondition === "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleInterior
                        .steeringCondition === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleInterior.steering ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  {/* <tr style={{height:"10px"}}>
                    <td width="35%">Air Conditioner</td>
                    <td width="30%"> {caseinfo.accessories.ac}</td>
                    <td width="30%">
                      {caseinfo.accessories.ac === "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr> */}
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Dashboard</td>
                    <td width="30%">
                      {caseinfo.construction.vehicleInterior.dashboard}
                    </td>
                    <td width="30%">
                      {caseinfo.construction.vehicleInterior.dashboard ===
                        "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleInterior.dashboard ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleInterior.dashboard ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleInterior.dashboard ===
                        "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleInterior.dashboard ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Seats</td>
                    <td width="30%">
                      {caseinfo.construction.vehicleInterior.seats}
                    </td>
                    <td width="30%">
                      {caseinfo.construction.vehicleInterior.seats ===
                        "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleInterior.seats ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleInterior.seats ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleInterior.seats ===
                        "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleInterior.seats ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Interior Trims</td>
                    <td width="30%">
                      {caseinfo.construction.vehicleInterior.interiorsTrims}
                    </td>
                    <td width="30%">
                      {caseinfo.construction.vehicleInterior.interiorsTrims ===
                        "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleInterior.interiorsTrims ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleInterior.interiorsTrims ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleInterior.interiorsTrims ===
                        "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleInterior.interiorsTrims ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">AirBag</td>
                    <td width="30%">
                      {caseinfo.construction.vehicleInterior.airBag}
                    </td>
                    <td width="30%">
                      {caseinfo.construction.vehicleInterior.airBag ===
                        "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">
                      Anti-lock Braking System (ABS)
                    </td>
                    <td width="30%">
                      {
                        caseinfo.construction.vehicleInterior
                          .antilockBrakeSystem
                      }
                    </td>
                    <td width="30%">
                      {caseinfo.construction.vehicleInterior
                        .antilockBrakeSystem === "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Power Window Front</td>
                    <td width="30%">
                      {caseinfo.construction.vehicleInterior.powerWindowFront}
                    </td>
                    <td width="30%">
                      {caseinfo.construction.vehicleInterior
                        .powerWindowFront === "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Power Window Rear</td>
                    <td width="30%">
                      {caseinfo.construction.vehicleInterior.powerWindowRear}
                    </td>
                    <td width="30%">
                      {caseinfo.construction.vehicleInterior.powerWindowRear ===
                        "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Seat Belts</td>
                    <td width="30%">
                      {caseinfo.construction.vehicleInterior.seatBelts}
                    </td>
                    <td width="30%">
                      {caseinfo.construction.vehicleInterior.seatBelts ===
                        "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">
                      Inside Rear View  Mirror (IRVM)
                    </td>
                    <td width="30%">
                      {
                        caseinfo.construction.vehicleInterior
                          .insideRearViewMirror
                      }
                    </td>
                    <td width="30%">
                      {caseinfo.construction.vehicleInterior
                        .insideRearViewMirror === "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
              <h4 style={{ marginTop: "5px" }}>
                <strong>VEHICLE EXTERIOR</strong>
              </h4>
              <table className="rowheight" width="100%">
                <tbody>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Bonnet</td>
                    <td width="30%">
                      {caseinfo.construction.vehicleExterior.bonnet}
                    </td>
                    <td width="30%">
                      {caseinfo.construction.vehicleExterior.bonnet ===
                        "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior.bonnet ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior.bonnet ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior.bonnet ===
                        "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior.bonnet ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Front Bumper</td>
                    <td width="30%">
                      {caseinfo.construction.vehicleExterior.frontBumper}
                    </td>
                    <td width="30%">
                      {caseinfo.construction.vehicleExterior.frontBumper ===
                        "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior.frontBumper ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior.frontBumper ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior.frontBumper ===
                        "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior.frontBumper ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Rear Bumper</td>
                    <td width="30%">
                      {caseinfo.construction.vehicleExterior.rearBumper}
                    </td>
                    <td width="30%">
                      {caseinfo.construction.vehicleExterior.rearBumper ===
                        "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior.rearBumper ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior.rearBumper ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior.rearBumper ===
                        "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior.rearBumper ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Windscreen</td>
                    <td width="30%">
                      {caseinfo.construction.vehicleExterior.windScreen}
                    </td>
                    <td width="30%">
                      {caseinfo.construction.vehicleExterior.windScreen ===
                        "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior.windScreen ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior.windScreen ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior.windScreen ===
                        "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior.windScreen ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Windscreen Glass</td>
                    <td width="30%">
                      {caseinfo.construction.vehicleExterior.windscreenGlass}
                    </td>
                    <td width="30%"></td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">RearWindScreenGlass</td>
                    <td width="30%">
                      {
                        caseinfo.construction.vehicleExterior
                          .rearWindScreenGlass
                      }
                    </td>
                    <td width="30%">
                      {caseinfo.construction.vehicleExterior
                        .rearWindScreenGlass === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior
                        .rearWindScreenGlass === "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior
                        .rearWindScreenGlass === "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior
                        .rearWindScreenGlass === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior
                        .rearWindScreenGlass === "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">RhSideBody</td>
                    <td width="30%">
                      {caseinfo.construction.vehicleExterior.rhSideBody}
                    </td>
                    <td width="30%">
                      {caseinfo.construction.vehicleExterior.rhSideBody ===
                        "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior.rhSideBody ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior.rhSideBody ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior.rhSideBody ===
                        "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior.rhSideBody ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">LhSideBody</td>
                    <td width="30%">
                      {caseinfo.construction.vehicleExterior.lhSideBody}
                    </td>
                    <td width="30%">
                      {caseinfo.construction.vehicleExterior.lhSideBody ===
                        "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior.lhSideBody ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior.lhSideBody ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior.lhSideBody ===
                        "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior.lhSideBody ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">LhDoorGlasses</td>
                    <td width="30%">
                      {caseinfo.construction.vehicleExterior.lhDoorGlasses}
                    </td>
                    <td width="30%">
                      {caseinfo.construction.vehicleExterior.lhDoorGlasses ===
                        "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior.lhDoorGlasses ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior.lhDoorGlasses ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior.lhDoorGlasses ===
                        "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior.lhDoorGlasses ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">OutsideRearViewMirror</td>
                    <td width="30%">
                      {
                        caseinfo.construction.vehicleExterior
                          .outsideRearViewMirror
                      }
                    </td>
                    <td width="30%">
                      {caseinfo.construction.vehicleExterior
                        .outsideRearViewMirror === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior
                        .outsideRearViewMirror === "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior
                        .outsideRearViewMirror === "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior
                        .outsideRearViewMirror === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior
                        .outsideRearViewMirror === "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Paint</td>
                    <td width="30%">
                      {caseinfo.construction.vehicleExterior.paint}
                    </td>
                    <td width="30%"></td>
                  </tr>
                  <tr>
                    <td width="35%">paintCondition</td>
                    <td width="30%">
                      {caseinfo.construction.vehicleExterior.paintCondition}
                    </td>
                    <td width="30%">
                      {caseinfo.construction.vehicleExterior.paintCondition ===
                        "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior.paintCondition ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior.paintCondition ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior.paintCondition ===
                        "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior.paintCondition ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">OverallBodyCondition</td>
                    <td width="30%">
                      {
                        caseinfo.construction.vehicleExterior
                          .overallBodyCondition
                      }
                    </td>
                    <td width="30%">
                      {caseinfo.construction.vehicleExterior
                        .overallBodyCondition === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior
                        .overallBodyCondition === "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior
                        .overallBodyCondition === "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior
                        .overallBodyCondition === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.vehicleExterior
                        .overallBodyCondition === "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
              <h4 style={{ marginTop: "5px" }}>
                <strong>WHEELS</strong>
              </h4>
              <table className="rowheight" width="100%">
                <tbody>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Wheel Type</td>
                    <td width="30%"> {caseinfo.otherDetails.wheelsType}</td>
                    <td width="30%">---</td>
                  </tr>
                </tbody>
              </table>
              <h4 style={{ marginTop: "5px" }}>
                <strong>ELECTRICALS:</strong>
              </h4>
              <table className="rowheight" width="100%">
                <tbody>
                  <tr>
                    <td width="35%">Battery Condition</td>
                    <td width="30%">
                      {caseinfo.construction.electricals.battery}
                    </td>
                    <td width="30%">
                      {caseinfo.construction.electricals.battery === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.electricals.battery ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.electricals.battery ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.electricals.battery === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.electricals.battery ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td width="35%">Instrument Cluster</td>
                    <td width="30%">
                      {caseinfo.construction.electricals.instrumentClustor}
                    </td>
                    <td width="30%">
                      {caseinfo.construction.electricals.instrumentClustor ===
                        "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.electricals.instrumentClustor ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.electricals.instrumentClustor ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.electricals.instrumentClustor ===
                        "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.electricals.instrumentClustor ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td width="35%">HeadLamp</td>
                    <td width="30%">{caseinfo.otherDetails.headLamp}</td>
                    <td width="30%">
                      {caseinfo.otherDetails.headLamp === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.headLamp === "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.headLamp === "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.headLamp === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.headLamp === "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td width="35%">TailLamp</td>
                    <td width="30%">{caseinfo.otherDetails.tailLamp}</td>
                    <td width="30%">
                      {caseinfo.otherDetails.tailLamp === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.tailLamp === "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.tailLamp === "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.tailLamp === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.tailLamp === "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td width="35%">Front Indicators</td>
                    <td width="30%">{caseinfo.otherDetails.frontIndicators}</td>
                    <td width="30%">
                      {caseinfo.otherDetails.frontIndicators === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.frontIndicators === "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.frontIndicators ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.frontIndicators === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.frontIndicators === "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td width="35%">Rear Indicators</td>
                    <td width="30%">{caseinfo.otherDetails.rearIndicators}</td>
                    <td width="30%">
                      {caseinfo.otherDetails.rearIndicators === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.rearIndicators === "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.rearIndicators ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.rearIndicators === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.rearIndicators === "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td width="35%">Fog Lamps</td>
                    <td width="30%">
                      {caseinfo.accessories.fogLamps}
                    </td>
                    <td width="30%">
                      {caseinfo.accessories.fogLamps === "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td width="35%">Fog Lamps Condition</td>
                    <td width="30%">
                      {caseinfo.construction.electricals.fogLampCondition}
                    </td>
                    <td width="30%">
                      {caseinfo.construction.electricals.fogLampCondition ===
                        "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.electricals.fogLampCondition ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.electricals.fogLampCondition ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.electricals.fogLampCondition ===
                        "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.construction.electricals.fogLampCondition ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
              <h4 style={{ marginTop: "5px" }}>
                <strong>ACCESSORIES(IF ANY)</strong>
              </h4>
              <table className="rowheight" width="100%">
                <tbody>
                  <tr>
                    <td width="35%">Sunroof</td>
                    <td width="30%">
                      {caseinfo.construction.accessories.sunroof}
                    </td>
                    <td width="30%">
                      {caseinfo.construction.accessories.sunroof === "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td width="35%">MusicSystem</td>
                    <td width="30%">
                      {caseinfo.construction.accessories.musicStytem}
                    </td>
                    <td width="30%">
                      {caseinfo.construction.accessories.musicStytem ===
                        "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td width="35%">RoofRails</td>
                    <td width="30%">
                      {caseinfo.construction.accessories.roofRails}
                    </td>
                    <td width="30%">
                      {caseinfo.construction.accessories.roofRails === "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td width="35%">SeatCovers</td>
                    <td width="30%">
                      {caseinfo.construction.accessories.seatCover}
                    </td>
                    <td width="30%">
                      {caseinfo.construction.accessories.seatCover === "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td width="35%">Antenna</td>
                    <td width="30%">
                      {caseinfo.construction.accessories.antenna}
                    </td>
                    <td width="30%">
                      {caseinfo.construction.accessories.antenna === "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td width="35%">Reverse Camera</td>
                    <td width="30%">
                      {caseinfo.construction.accessories.reverseCamera}
                    </td>
                    <td width="30%">
                      {caseinfo.construction.accessories.reverseCamera ===
                        "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>

              {/* <div style={{ marginTop: 30 }}>&nbsp;</div> */}
              <div className="row">
                <div className="col-sm-12 newReport">
                  <div
                    style={{
                      padding: 2,
                      border: "1px solid #000",
                      width: "100%",
                    }}
                  >
                    {/* page footer */}
                    <div className="col-sm-12 newReport text-center">
                      <strong>Head Office:</strong>
                      <br />
                      Door No. 411,4th Floor, Eden Amsri Square,beside Apollo
                      Hospital, Sangeet Circle,
                      <br />
                      Secunderabad 500003, Telengana
                    </div>
                  </div>
                </div>
                {/* page footer ends */}
              </div>
              <div style={{ marginTop: 10 }}>&nbsp;</div>
            </div>
            {/* <!-- page 4 ends --> */}
            <div className="page-break" />
            <div style={{ marginTop: 10 }}>&nbsp;</div>
            {/* <div
              style={{
                padding: "2px 25px",
                border: "1px solid #000",
                width: "100%",
              }}
            >
              <div className="row">
                <div className="col-sm-3 p-2">
                  <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/toplogo.png" />
                </div>
                <div className="col-sm-6 text-center">
                  <br />
                  <h4>
                    <strong>
                      Valuation Report
                      <br />
                      {caseinfo.assetType}
                      <br />
                      {`${caseinfo.brand} ${caseinfo.model} ${caseinfo.variant}`}
                    </strong>
                  </h4>
                  &nbsp;
                </div>
                <div className="col-sm-3 text-right">
                  <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png" />
                </div>
              </div>
            </div> */}
            {/*-  header */}

            {/*- content border */}
            <h4>
              <strong>
                IMAGES:
              </strong>
            </h4>
            <div className="row">
              <div className="col-sm-12 newReport">
                <table className="rowheight" width="100%">
                  <tbody>
                    <tr>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.selfieWithVehicle}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.selfieWithVehicle}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.frontImage}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.frontImage}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.frontUnderCar}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.frontUnderCar}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.rearImage}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.rearImage}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.rearUnderPart}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.rearUnderPart}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.right45}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.right45}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div style={{ marginTop: 12 }}>&nbsp;</div>
                <div className="row">
                  <div className="col-sm-12 newReport">
                    <div
                      style={{
                        padding: 2,
                        border: "1px solid #000",
                        width: "100%",
                      }}
                    >
                      {/* page footer */}
                      <div className="col-sm-12 newReport text-center">
                        <strong>Head Office:</strong>
                        <br />
                        Door No. 411,4th Floor, Eden Amsri Square,beside Apollo
                        Hospital, Sangeet Circle,
                        <br />
                        Secunderabad 500003, Telengana
                      </div>
                    </div>
                  </div>
                  {/* page footer ends */}
                </div>
                <div style={{ marginTop: 5 }}>&nbsp;</div>
                {/* <div className="page-break" /> */}
                {/*div class="content" style="margin:30px 0 0 0; padding:0 10px; width:100%;border:1px solid #00f;" */}
                <div style={{ marginTop: 10 }}>&nbsp;</div>
                <div
                  style={{
                    padding: "2px 25px",
                    border: "1px solid #000",
                    width: "100%",
                  }}
                >
                  <div className="row">
                    <div className="col-sm-3 p-2">
                      <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/toplogo.png" />
                    </div>
                    <div className="col-sm-6 text-center">
                      <br />
                      <h4>
                        <strong>
                          Valuation Report
                          <br />
                          {caseinfo.assetType}
                          <br />
                          {`${caseinfo.brand} ${caseinfo.model} ${caseinfo.variant}`}
                        </strong>
                      </h4>
                      {/* Ex. Showroom Price&nbsp;:&nbsp;3300000 */}
                    </div>
                    <div className="col-sm-3 text-right">
                      <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png" />
                    </div>
                  </div>
                </div>
                {/*-  header */}
                <table>
                  <tbody>
                    <tr />
                    <tr>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.rightImage}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.rightImage}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.left45}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.left45}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.leftImage}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.leftImage}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.chasisImage}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.chasisImage}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.openBonnet}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.openBonnet}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.openDickey}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.openDickey}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div style={{ marginTop: 12 }}>&nbsp;</div>
                <div className="row">
                  <div className="col-sm-12 newReport">
                    <div
                      style={{
                        padding: 2,
                        border: "1px solid #000",
                        width: "100%",
                      }}
                    >
                      {/* page footer */}
                      <div className="col-sm-12 newReport text-center">
                        <strong>Head Office:</strong>
                        <br />
                        Door No. 411,4th Floor, Eden Amsri Square,beside Apollo
                        Hospital, Sangeet Circle,
                        <br />
                        Secunderabad 500003, Telengana
                      </div>
                    </div>
                  </div>
                  {/* page footer ends */}
                </div>
                <div style={{ marginTop: 5 }}>&nbsp;</div>
                <div className="page-break" />
                {/*div class="content" style="margin:30px 0 0 0; padding:0 10px; width:100%;border:1px solid #00f;" */}
                <div style={{ marginTop: 10 }}>&nbsp;</div>
                <div
                  style={{
                    padding: "2px 25px",
                    border: "1px solid #000",
                    width: "100%",
                  }}
                >
                  <div className="row">
                    <div className="col-sm-3 p-2">
                      <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/toplogo.png" />
                    </div>
                    <div className="col-sm-6 text-center">
                      <br />
                      <h4>
                        <strong>
                          Valuation Report
                          <br />
                          {caseinfo.assetType}
                          <br />
                          {`${caseinfo.brand} ${caseinfo.model} ${caseinfo.variant}`}
                        </strong>
                      </h4>
                      {/* Ex. Showroom Price&nbsp;:&nbsp;3300000 */}
                    </div>
                    <div className="col-sm-3 text-right">
                      <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png" />
                    </div>
                  </div>
                </div>
                {/*-  header */}
                <table>
                  <tbody>
                    <tr />
                    <tr>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.tyreImage}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.tyreImage}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.glassInside}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.glassInside}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.glassOutside}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.glassOutside}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.odometerImage}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.odometerImage}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.rpmImage}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.rpmImage}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.tyreImage}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.tyreImage}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div style={{ marginTop: 8 }}>&nbsp;</div>
                <div className="row">
                  <div className="col-sm-12 newReport">
                    <div
                      style={{
                        padding: 2,
                        border: "1px solid #000",
                        width: "100%",
                      }}
                    >
                      {/* page footer */}
                      <div className="col-sm-12 newReport text-center">
                        <strong>Head Office:</strong>
                        {/* <br /> */}
                        <p> Door No. 411,4th Floor, Eden Amsri Square,beside Apollo
                          Hospital, Sangeet Circle,</p>
                        {/* <br /> */}
                        <p> Secunderabad 500003, Telengana</p>
                      </div>
                    </div>
                  </div>
                  {/* page footer ends */}
                </div>
                <div style={{ marginTop: 5 }}>&nbsp;</div>
                <div className="page-break" />
                {/*div class="content" style="margin:30px 0 0 0; padding:0 10px; width:100%;border:1px solid #00f;" */}
                <div style={{ marginTop: 10 }}>&nbsp;</div>
                <div
                  style={{
                    padding: "2px 25px",
                    border: "1px solid #000",
                    width: "100%",
                  }}
                >
                  <div className="row">
                    <div className="col-sm-3 p-2">
                      <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/toplogo.png" />
                    </div>
                    <div className="col-sm-6 text-center">
                      {/* <br /> */}
                      <h4>
                        <strong>
                          Valuation Report
                          {/* <br /> */}
                          <p>{caseinfo.assetType}</p>
                          {/* <br /> */}
                          <p> {`${caseinfo.brand} ${caseinfo.model} ${caseinfo.variant}`}</p>
                        </strong>
                      </h4>
                      {/* Ex. Showroom Price&nbsp;:&nbsp;3300000 */}
                    </div>
                    <div className="col-sm-3 text-right">
                      <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png" />
                    </div>
                  </div>
                </div>
                {/*-  header */}
                <table>
                  <tbody>
                    <tr />
                    <tr>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.anyDamage}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.images.anyDamage}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.rcBack}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.signNdoc.rcBack}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.rcFront}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.signNdoc.rcFront}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                      <td width="50%" style={{ padding: 10 }}>
                        <a target="_blank" href={caseinfo.images.sign}>
                          <div style={{ position: "relative" }}>
                            <img
                              src={caseinfo.signNdoc.sign}
                              style={{ height: "240px", width: "410px" }}
                            />
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                              className="small-logo"
                              width="75px"
                              height="53px"
                            />
                          </div>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div className="row">
                  <div className="col-sm-12 newReport">
                    <div
                      style={{
                        padding: "15px 10px",
                        border: "1px solid #686868",
                      }}
                    >
                      Disclaimer:
                      {/* <br /> */}
                      <p> o This report is issued without prejudice</p>
                      {/* <br /> */}
                      <p> o The valuation has been done based on the superficial
                        examination of vehicle condition and the doeuments
                        provided at the time of inspection.</p>
                      {/* <br /> */}
                      <p> o This report is valid for the date of inspection and time
                        only</p>
                      {/* <br /> */}
                      <p> o This valuation has been performed to the best of our
                        ability and our responsibility is limited to proven
                        negligence.</p>
                      {/* <br /> */}
                      <div className="text-right" style={{ display: "flex", justifyContent: "flex-end", alignItems: "end", marginRight: "20px" }}>
                        <img
                          src="/assets/stamp.jpeg"
                          width="80px"
                          height="80px"
                        /></div>
                      <div className="text-right">

                        {/* <br /> */}
                        Authorized Signatory
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ marginTop: 8 }}>&nbsp;</div>
                <div className="row">
                  <div className="col-sm-12 newReport">
                    <div
                      style={{
                        padding: 2,
                        border: "1px solid #000",
                        width: "100%",
                      }}
                    >
                      {/* page footer */}
                      <div className="col-sm-12 newReport text-center">
                        <strong>Head Office:</strong>
                        {/* <br /> */}
                        <p>
                          {" "}
                          Door No. 411,4th Floor, Eden Amsri Square,beside
                          Apollo Hospital, Sangeet Circle,
                        </p>
                        {/* <br /> */}
                        <p> Secunderabad 500003, Telengana</p>
                      </div>
                    </div>
                  </div>
                  {/* page footer ends */}
                </div>
              </div>
            </div>
            <br />
            {/* /div> <!-- A4 size */}
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default ConstructionReport;
